import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { mapFormData } from 'helpers/formData';

interface ClientTopUpUpdatePrivateNotePatchOptions {
  privateNote?: string;
  sendToPracticeNotes?: boolean;
}

export function clientTopUpUpdatePrivateNoteApi(path: string) {
  return {
    path,
    PATCH: (params: ClientTopUpUpdatePrivateNotePatchOptions) =>
      api.patch<JsonApiResponseSingle>(path, {
        data: {
          attributes: mapFormData(params),
        },
      }),
  };
}
